<template>
  <v-dialog
    content-class="c-modal"
    :width="width"
    v-model="shouldShow"
    :persistent="persistent"
  >
    <div class="rounded-10 content-wrap">
      <v-icon
        v-if="!hideCloseBtn"
        class="close-icon clickable"
        small
        @click="close"
        >mdi-close</v-icon
      >
      <div :class="[contentClass]">
        <slot />
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "502px",
    },
    value: {
      type: Boolean,
    },
    hideCloseBtn: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: "rounded-8 py-8 px-5 pa-lg-10 white",
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shouldShow: this.value,
    };
  },
  methods: {
    close() {
      this.shouldShow = false;
      this.$emit("onClosed");
    },
  },
  watch: {
    value(val) {
      this.shouldShow = val;
    },
    shouldShow(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-modal {
  .content-wrap {
    position: relative;
    .close-icon {
      position: absolute;
      right: 12px;
      top: 12px;
      color: var(--icongray);
      &:hover {
        color: var(--gray);
      }
    }
  }
}
</style>